import { faTrashCan } from "@fortawesome/pro-duotone-svg-icons";
import { Input } from "@progress/kendo-react-inputs";
import ColorChangingIcon from "../../../Common/UI/ColorChangingIcon";
import { datasetData } from "../../NewDatasetSignals";

export const ValueCell = (props) => {
  const handleValueChange = (e) => {
    const inEditID = props.dataItem.id;
    const newData = props.data.map((item) =>
      item.id === inEditID
        ? {
            ...item,
            value: e.target.value,
          }
        : item
    );
    datasetData.value = { ...datasetData.value, values: newData };
  };

  return (
    <td>
      <Input
        className={props.dataItem.value ? "!k-valid" : "!k-invalid"}
        type="text"
        defaultValue={props.dataItem.value}
        onBlur={handleValueChange}
        required
      />
    </td>
  );
};

export const ParameterValueCell = (props) => {
  const handleValueChange = (e) => {
    const inEditID = props.dataItem.id;
    const newData = props.data.map((item) =>
      item.id === inEditID
        ? {
            ...item,
            filterValue: e.target.value,
          }
        : item
    );
    datasetData.value = { ...datasetData.value, values: newData };
  };

  return (
    <td>
      <Input
        className={props.dataItem.filterValue ? "!k-valid" : "!k-invalid"}
        type="text"
        defaultValue={props.dataItem.filterValue}
        onBlur={handleValueChange}
        required
      />
    </td>
  );
};

export const DeleteCell = (props) => {
  const handleDeleteRecord = () => {
    const newData = props.data.filter((item) => item.id !== props.dataItem.id);
    datasetData.value = { ...datasetData.value, values: newData };
  };

  return (
    <td>
      <ColorChangingIcon
        icon={faTrashCan}
        initialPrimaryColor="#6e6e6e"
        initialSecondaryColor="#919191"
        padding="0 2px 0 0"
        onClick={handleDeleteRecord}
      />
    </td>
  );
};
